/** API route map: URLS.Controller.PayrollNaicsCodeSetup */
export const PayrollNaicsCodeSetup = {
      Name: 'PayrollNaicsCodeSetup/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      GetNAICSCode: 'get-naics-code',
      GetJNaicsclients: 'get-clients',
};
